const StrDataFormatOne = (str) => str
    .normalize('NFD')
    .toLowerCase()
    .replaceAll(' ', '')
    .replace(/[\u0300-\u036f]/g, '')

export default StrDataFormatOne;
